import { call, put, takeEvery } from "redux-saga/effects";
import {
    GET_PAY_OUT_STATUS_DEF,
} from "./actionTypes"

import {
    getPayOutStatusDefListSuccess,
    payOutStatusDefApiError
} from "./actions"

import {
    GetAllPayOutStatusDef,
} from "../../helpers/backend_helper/backend_helper"

function* onGetPayOutStatusDefList() {
  try {
    const response = yield call(GetAllPayOutStatusDef)
    yield put(getPayOutStatusDefListSuccess(response))
  } catch (error) {
    yield put(payOutStatusDefApiError(error))
  }
}

function* payOutStatusDefSaga() {
    yield takeEvery(GET_PAY_OUT_STATUS_DEF,onGetPayOutStatusDefList)
}

export default payOutStatusDefSaga